import Image from "next/image";
import React, { useState } from "react";
import CalendarButton from "./CalendarButton";
import FavoriteButton from "./FavoriteButton";
import Ribbon from "./Ribbon";
import { Blur, Remote } from "@/api/loaderRemote";
import dynamic from "next/dynamic";
import Link from "next/link";
import PrevButton from "./PrevButton";
import NextButton from "./NextButton";

const CalendarModal = dynamic(() => import("../modals/CalendarModal"), {
  ssr: false,
});

const Carousel = ({
  villa,
  currentIndex,
  handlePrev,
  handleNext,
  listVilla,
  hasMultipleImages,
  images,
  priority,
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const isPrevDisabled = currentIndex === 0;
  const isNextDisabled = currentIndex === images?.length - 1;

  const [total, setTotal] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
      isShow: 0,
    },
  ]);

  return (
    <div
      className={`relative ${
        listVilla
          ? "sm:w-[316px] lg:w-64 lgx:w-[316px] w-full flex-shrink-0"
          : "mb-5"
      }`}
    >
      <div className="relative flex items-center">
        {hasMultipleImages && (
          <PrevButton handlePrev={handlePrev} disabled={isPrevDisabled} />
        )}
        <Link
          title={villa.title}
          href={villa.url || "#"}
          prefetch={false}
          className="flex justify-center w-full overflow-hidden rounded-lg"
        >
          <Image
            src={images[currentIndex]}
            alt={villa?.name}
            width={316}
            height={200}
            placeholder="blur"
            loader={Remote}
            blurDataURL={Blur(images[currentIndex])}
            priority={priority || false}
            sizes="(max-width: 640px) 75vw,
              50vw"
            className="object-cover w-full aspect-[316/200]"
          />
        </Link>
        {hasMultipleImages && (
          <NextButton handleNext={handleNext} disabled={isNextDisabled} />
        )}
      </div>
      <Ribbon villa={villa} />
      <div className="absolute flex flex-col gap-1 top-1 right-1">
        <FavoriteButton data={villa}>
          <Image
            src={"/icons/card-heart.svg"}
            alt="card-heart"
            width={14}
            height={14}
            className="object-contain"
          />
        </FavoriteButton>
        <CalendarButton setIsOpenModal={setIsOpenModal} />
      </div>
      {isOpenModal && (
        <CalendarModal
          villa={villa}
          selected={total}
          setSelected={setTotal}
          openModal={isOpenModal}
          setOpenModal={setIsOpenModal}
        />
      )}
    </div>
  );
};

export default Carousel;
